<template>
  <div class="animated fadeIn">
    <b-card class="mt-4">
      <b-row>
        <b-col>
          <b-form-group label="Project" :label-cols="3">
            <b-form-input
              type="text"
              v-model="submission_data.identifier"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="Event Code" :label-cols="3">
            <b-form-input
              type="text"
              v-model="submission_data.event_code"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <div v-if="submission_data.samples && submission_data.samples.length">
        <hr />
        <general-sample-form-group
          v-for="(sample, sampleIndex) in submission_data.samples"
          :key="sampleIndex"
          :sample="sample"
          :addOns="addOns"
          :index="sampleIndex"
          @onSampleChange="onSampleChange"
        ></general-sample-form-group>
      </div>
      <hr />
      <turn-around-select
        :turnArounds="turnArounds"
        :selectedTurnAround="submission_data.turnaround"
        @onTurnAroundSelect="onTurnAroundSelect"
      ></turn-around-select>
      <div v-if="serviceQuestions && serviceQuestions.models.length">
        <hr />
        <service-question
          v-for="(serviceQuestion, index) in serviceQuestions.models"
          :serviceQuestion="serviceQuestion"
          :key="index"
        ></service-question>
      </div>
      <b-button variant="danger" block @click="removeSubmission"
        ><i class="fal fa-trash"></i
      ></b-button>
    </b-card>
  </div>
</template>

<script>
import GeneralSampleFormGroup from "./GeneralSampleFormGroup";
import TurnAroundSelect from "../../TurnAroundSelect";
import TestPackageSampleCollection from "../../../../collections/lab/TestPackageSampleCollection";
import TestPackageCollection from "../../../../collections/lab/TestPackageCollection";
import TurnaroundCollection from "../../../../collections/lab/TurnaroundCollection";
import ServiceQuestionCollection from "../../../../collections/lab/ServiceQuestionCollection";

export default {
  name: "GeneralForm",
  components: {
    TurnAroundSelect,
    GeneralSampleFormGroup
  },
  props: {
    submission: {
      type: Object,
      default: () => null
    },
    testPackageSamples: {
      type: Object,
      default: () => new TestPackageSampleCollection()
    },
    addOns: {
      type: Object,
      default: () => new TestPackageCollection()
    },
    turnArounds: {
      type: Object,
      default: () => new TurnaroundCollection()
    },
    index: {
      type: Number,
      default: null
    },
    serviceQuestions: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    }
  },
  data() {
    return {
      submission_data: null
    };
  },
  methods: {
    onSampleChange(params) {
      if (params) {
        let sample = params.sample;
        let index = params.index;
        if (
          this.submission_data.samples &&
          this.submission_data.samples.length &&
          sample &&
          index !== null
        ) {
          this.submission_data.samples.splice(index, 1, sample);
          this.emitSubmissionChange();
        }
      }
    },
    onTurnAroundSelect(turnaround) {
      if (turnaround && turnaround.id) {
        this.submission_data.turnaround = turnaround;
        this.emitSubmissionChange();
      }
    },
    emitSubmissionChange() {
      this.$emit("onSubmissionChange", {
        submission: this.submission_data,
        index: this.index
      });
    },
    removeSubmission() {
      this.$emit("removeSubmission", this.index);
    }
  },
  watch: {
    form: {
      handler() {
        this.emitSubmissionChange();
      },
      deep: true
    },
    submission: {
      handler(value) {
        this.submission_data = value;
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.submission) {
      this.submission_data = this.submission;
    }
  }
};
</script>
